///
/// typescript 형식을 따르기 위해 window 객체에 config 타입 정의
///
declare global {
  interface Window {
    config: {};
  }
}

let Config = {} as any; /// 프로그램 환경설정 내용 저장 변수

/**
 * 내부적인 App 설정 사항 및 Default 값 지정
 */
const appDefaultConfig = {
  APP_MIN_CLIENT_HEIGHT: 565,
  support: {
    webWorker: false,
  },

  privateSupport: {
    isEnableScalebarTool: true,
    isEnableImageFusion: false,
    isEnableMPR: false,
  },
  layout: {
    maxRows: 4,
    maxColumns: 4,
    defaultRows: 2,
    defaultColumns: 3,
  },
  elementView: {
    //metadataTextColor: "#06ABD8",
    metadataTextColor: "#ffffff",
  },
  license: {
    expirationDate: "2025.12.31",
  },
  /**
   * winston logger
   */
  logs: {
    level: process.env.LOG_LEVEL || "silly",
  },
};

/**
 * 내부용 App 설정 config와 외부용 config 을 병합
 */
if (typeof window !== "undefined" && window && window.config !== undefined) {
  Config = window.config || {};
} else if ((self as any).importScripts) {
  (self as any).importScripts("./iAidDicomLib.js");
  (self as any).importScripts("./config.js");
  Config = self.config;
}

Config = Object.assign({}, appDefaultConfig, Config);

// WebWorker 기능 사용시, 브라우저 지원 여부 확인
if (Config.support.webWorker === true) {
  Config.support.webWorker =
    typeof window === "undefined" ? true : !!(window as any).Worker;
}

process.env.__DEV__ = "true";

///
/// 프로그램 환경설정 변수 Export
/// 
export default Config;
